"use client";
import React, { memo, PropsWithChildren, useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import { useInView } from "framer-motion";
import { cn } from "@onair/utils/cn";

export type InfiniteScrollListProps = PropsWithChildren & {
	onReachEnd: (isInview: boolean) => void;
	fetchingNextPageComponent?: React.ReactNode;
	isFetchingNextPage?: boolean;
	className?: string;
};
const InfiniteScrollList: React.FC<InfiniteScrollListProps> = ({
	children,
	isFetchingNextPage,
	fetchingNextPageComponent,
	onReachEnd,
	className = "",
}) => {
	const cursorRef = useRef<HTMLDivElement>(null);
	const isInview = useInView(cursorRef);
	useEffect(() => {
		onReachEnd?.(isInview);
	}, [isInview]);
	return (
		<Box
			component="div"
			className={cn("infinite-scroll-list", {
				[className]: className,
			})}
		>
			{children}
			<Box component="div" ref={cursorRef}>
				{isFetchingNextPage ? (
					<React.Fragment>
						{fetchingNextPageComponent ? (
							fetchingNextPageComponent
						) : (
							<Box component="div" className="text-center text-white py-6">
								<Typography>Đang tải...</Typography>
							</Box>
						)}
					</React.Fragment>
				) : null}
			</Box>
		</Box>
	);
};
export default memo(InfiniteScrollList);
